import RadioContext from "./RadioContext";
import React, {useContext, useEffect, useState} from "react";
import PropTypes from "prop-types";

const RadioButton = (props) => {
    const radioContext = useContext(RadioContext);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        setChecked(isChecked(radioContext));
    }, [radioContext.value])

    const isChecked = (radioContext) => {
        return radioContext.value === props.id;
    }

     const className = (props.className ? " " + props.className : "")
            + (props.type ? " is-" + props.type : "")
            + (props.isOutlined ? " is-outlined" : "")
            + (props.color ? " is-" + props.color : "");

    return (
      <label className={"field radio loadable " + className}>
        <input
          id={props.id}
          type="radio"
          disabled={props.disabled}
          checked={checked}
          onChange={radioContext.onChange}
        />
        <span className="disable-select">{props.label}</span>
      </label>
    )
}

RadioButton.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    isOutlined: PropTypes.bool,
    className: PropTypes.string,
    type: PropTypes.oneOf(["circle", "form"]),
    color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger", "auto"]),
};

export default RadioButton;